<template>
  <section>
    <b-row>
      <b-col
        lg="8"
        md="12"
      >
        <b-overlay
          :show="loader"
          rounded="sm"
        >
          <recursos-list
            :data="resourses"
            :source-selected="selected"
            :updated-at="updatedAt"
            @sourceSelected="selected = $event"
            @updateData="loadResourses()"
          />
        </b-overlay>
      </b-col>

      <b-col
        lg="4"
        md="12"
      >
        <recursos-form
          :selected="selected"
          @cancelUpdate="selected = {}"
          @updateData="loadResourses()"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { BRow, BCol, BOverlay } from 'bootstrap-vue'
import { lastUpdate } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getResourses } from './components/recursos/useRecursos'
import RecursosList from './components/recursos/RecursosList.vue'
import RecursosForm from './components/recursos/RecursosForm.vue'

export default {
  components: {
    BRow,
    BCol,
    BOverlay,

    RecursosList,
    RecursosForm,
  },
  setup() {
    const toast = useToast()
    const resourses = ref([])
    const selected = ref({})
    const loader = ref(false)
    const updatedAt = ref('')

    const loadResourses = () => {
      loader.value = true
      getResourses().then(response => {
        updatedAt.value = lastUpdate()
        loader.value = false
        resourses.value = response
      }, error => {
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Carga de recursos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(() => {
      loadResourses()
    })

    return {
      // Variables
      resourses,
      selected,
      // Functions
      loadResourses,
      // Loaders
      loader,
      // Filters
      updatedAt,
    }
  },
}
</script>
